var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWatermellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "-18.91 0 483.84 483.84",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1A1F33;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Capa 2",
    id: "Capa_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Watermelon"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M223,0,0,401.81l6,4.44c1.06.8,26.6,19.68,66.12,38.79,66.32,32.06,118.68,38.8,150.92,38.8,58.42,0,114.32-21.1,150.93-38.8,39.51-19.11,65.05-38,66.12-38.79l6-4.44Zm0,35,172.68,311.1c-39.2,23.48-104.42,62.36-172.67,62.36S89.54,369.61,50.35,346.13Zm0,431.81c-90.85,0-177.54-54.22-200.82-70L42.09,361C82.85,385.41,150.36,425.49,223,425.49S363.17,385.41,403.93,361l19.9,35.86C400.58,412.63,314,466.84,223,466.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M264.92,283.25c.13,1.75,7.1,14.31,10.7,20.7a2,2,0,0,0,3.65-.27c2.62-6.86,7.64-20.31,7.51-22.06a11,11,0,1,0-21.86,1.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M252.28,231.66c6-4.24,17.66-12.61,18.53-14.14a11,11,0,0,0-19.07-10.82c-.87,1.53-2.07,15.84-2.64,23.16A2,2,0,0,0,252.28,231.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M222.16,152.35c4.43-5.86,13-17.37,13.37-19.09a11,11,0,0,0-21.45-4.53c-.36,1.72,2.83,15.72,4.5,22.86A2,2,0,0,0,222.16,152.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M182.48,280.76c.64,1.64,11,11.59,16.31,16.65a2,2,0,0,0,3.41-1.33c.48-7.33,1.34-21.66.7-23.3a11,11,0,1,0-20.42,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M325.73,337.62c5.46-4.91,16.08-14.57,16.76-16.19a11,11,0,1,0-20.18-8.54c-.69,1.62-.23,16,.05,23.3A2,2,0,0,0,325.73,337.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M179.89,221.91c3.77-6.3,11.05-18.67,11.23-20.42a11,11,0,0,0-21.81-2.19c-.18,1.75,4.5,15.32,6.94,22.24A2,2,0,0,0,179.89,221.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M214.85,360.78c6-4.3,17.52-12.81,18.37-14.35A11,11,0,0,0,214,335.83c-.85,1.54-1.89,15.86-2.38,23.18A2,2,0,0,0,214.85,360.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.2,305.28c.8,1.56,12.09,10.43,17.89,14.93a2,2,0,0,0,3.26-1.67c-.25-7.33-.83-21.68-1.63-23.24a11,11,0,1,0-19.52,10Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatermellow);
export default __webpack_public_path__ + "static/media/watermellow.e47c8ec9f006c185de8fad8a61f83ff4.svg";
export { ForwardRef as ReactComponent };